export default __webpack_public_path__ + "static/service2-e1bb90eccff98828f8086a4bc9a3be4c.png";